import update from 'immutability-helper';
import qwPartners from '../common/clients/qwPartners';
import I18n from '../../config/i18n';
import { updateWorkOrderWithMovieData } from '../common/utils/helpers';
import { handleAppError, showAppBusy } from './app';

const initialState = {
  loading: true,
  workOrder: null,
};

const RECEIVE = 'workOrder/RECEIVE';
const RESET = 'workOrder/RESET';
const UPDATE = 'workOrder/UPDATE';
const LOADING = 'workOrder/LOADING';

const UPDATE_TOTAL_WORK_ORDER_COPIED_STATUS =
  'workOrder/UPDATE_TOTAL_WORK_ORDER_COPIED_STATUS';

export function receiveWorkOrder(workOrder) {
  return { type: RECEIVE, payload: workOrder };
}

function fetchMappedMovie(workOrder, showLoading) {
  const compositionIds = workOrder.compositions.map((comp) => comp.composition);
  return (dispatch) => {
    dispatch(showAppBusy(showLoading));
    dispatch(updateLoading(showLoading));
    return qwPartners
      .post(`/v1/movies`, { compositions: compositionIds })
      .then((response) => {
        const updatedworkorder = updateWorkOrderWithMovieData(
          workOrder,
          response.data,
        );
        dispatch(receiveWorkOrder(updatedworkorder));
        dispatch(showAppBusy(false));
        dispatch(updateLoading(false));
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(updateLoading(false));
        dispatch(handleAppError(error, I18n.t('couldNotLoadWorkOrders')));
      });
  };
}
export function updateLoading(payload) {
  return { type: LOADING, payload };
}

export function resetWorkOrder() {
  return { type: RESET, payload: initialState };
}

function getWorkOrderById(workOrders, workOrderId) {
  return workOrders.find((workOrder) => workOrder.workOrderNo === workOrderId);
}

export function loadWorkOrder(workOrderId) {
  return (dispatch, getState) => {
    dispatch(updateLoading(true));
    const workOrders = getState().workOrders.workOrders;
    const foundWorkOrder = getWorkOrderById(workOrders, workOrderId);

    if (foundWorkOrder) {
      dispatch(receiveWorkOrder(foundWorkOrder));
      dispatch(updateLoading(false));
    }

    return dispatch(fetchWorkOrderFromServer(workOrderId, true));
  };
}

export function fetchWorkOrderFromServer(workOrderNo, showLoading) {
  return (dispatch, getState) => {
    const { user } = getState().account;
    const applianceCount = user.appliances.length;
    dispatch(updateLoading(showLoading));

    return qwPartners
      .get(`/v1/work-orders/${workOrderNo}?appliancesCount=${applianceCount}`)
      .then((res) => res.data)
      .then((workOrder) => {
        dispatch(fetchMappedMovie(workOrder, showLoading));
      })
      .catch((error) => {
        dispatch(updateLoading(false));
        dispatch(handleAppError(error, I18n.t('couldNotLoadWorkOrders')));
      });
  };
}

export function startDownload(workOrderNo, applianceId) {
  return (dispatch) => {
    dispatch(showAppBusy(true));
    return qwPartners
      .post(`/v1/work-orders/${workOrderNo}/download/${applianceId}`)
      .then(() => dispatch(fetchWorkOrderFromServer(workOrderNo, true)))
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('couldNotStartDownload')));
      });
  };
}

export function updateWorkOrderDrive(applianceId, driveTypeId) {
  return { type: UPDATE, payload: { applianceId, driveTypeId } };
}

export function updateTotalWorkOrderCopiedStatus(value) {
  return { type: UPDATE_TOTAL_WORK_ORDER_COPIED_STATUS, payload: value };
}

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case RECEIVE:
      return update(state, { $set: payload });

    case UPDATE:
      return Object.assign({}, state, payload);

    case UPDATE_TOTAL_WORK_ORDER_COPIED_STATUS:
      return update(state, { totalCopied: { $set: payload } });

    case LOADING:
      return update(state, { loading: { $set: payload } });

    case RESET:
      return update(state, { $set: payload });

    default:
      return state;
  }
}
